import store from '../../store/store';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Set the getInboxRuleRequestStatus in the inbox rules options store
 * @param requestStatus the get inbox rules request status to set
 * @param state the state which contains the store
 */
export default action('setGetInboxRuleRequestStatus')(select({
    optionState: function () { return store.inboxRulesListState; },
})(function setGetInboxRuleRequestStatus(requestStatus, state) {
    var optionState = state.optionState;
    optionState.getInboxRuleRequestStatus = requestStatus;
}));
//# sourceMappingURL=setGetInboxRuleRequestStatus.js.map